import { render } from "./allproductlocation.vue?vue&type=template&id=47396621&scoped=true"
import script from "./allproductlocation.vue?vue&type=script&lang=js"
export * from "./allproductlocation.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./allproductlocation.vue?vue&type=style&index=1&id=47396621&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47396621"]])

export default __exports__